import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Opd = () => {
  return (
    <section id="opd-management" className="landing opd-landing">
      <Helmet>
        <title>OPD Management Software India — Mediway Nextgen</title>
        <meta name="description" content="OPD management software for clinics and hospitals in India — appointment scheduling, queue management, EHR, and patient portals by Mediway Nextgen." />
        <link rel="canonical" href="https://mediwaynextgen.wayug.com/services/opd-management-software" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Product',
            'name': 'OPD Management Software',
            'description': 'OPD management with appointments, queueing, EHR and patient portal tailored for Indian clinics and hospitals.',
            'brand': 'Mediway Nextgen',
            'url': 'https://mediwaynextgen.wayug.com/services/opd-management-software'
          })}
        </script>
      </Helmet>

      <div className="container">
        <header className="section-header">
          <h2 className="section-title">OPD Management Software — Optimise Outpatient Care</h2>
          <p className="section-subtitle">Appointment scheduling, queue management, digital OPD workflows and patient engagement tools designed for Indian hospitals and clinics.</p>
        </header>

        <div className="service-content">
          <div className="service-header">
            <div className="service-icon">🏥</div>
            <div className="service-info">
              <h3 className="service-title">Efficient OPD Workflows</h3>
              <p className="service-description">Manage appointments, queues, triage and OPD documentation with an intuitive interface built for busy clinics and hospital outpatient departments.</p>
            </div>
          </div>

          <div className="service-body">
            <div className="service-features">
              <h4>Key Features</h4>
              <ul className="features-list">
                <li className="feature-item"><span className="feature-check">✓</span><span>Appointment scheduling &amp; reminders</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Doctor queue management &amp; triage</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>OPD-specific EHR templates &amp; notes</span></li>
                <li className="feature-item"><span className="feature-check">✓</span><span>Patient portal and SMS/Email notifications</span></li>
              </ul>
            </div>

            <div className="service-benefits">
              <h4>Benefits</h4>
              <div className="benefits-grid">
                <div className="benefit-card"><div className="benefit-icon">⏱️</div><span>Reduce waiting time</span></div>
                <div className="benefit-card"><div className="benefit-icon">📈</div><span>Increase OPD throughput</span></div>
                <div className="benefit-card"><div className="benefit-icon">📋</div><span>Accurate medical records</span></div>
              </div>
            </div>
          </div>

          <div className="service-actions">
            <Link to="/contact" className="btn btn-primary">Request OPD Demo</Link>
            <Link to="/services" className="btn btn-secondary">All Services</Link>
          </div>
        </div>
      </div>

      <div className="services-background">
        <div className="background-pattern"></div>
      </div>
    </section>
  );
};

export default Opd;